import { X } from "lucide-react";

import { Button } from "@/components/button";

interface ClearButtonProps {
  ariaLabel?: string;
  className?: string;
  onPress: () => void;
}

export function ClearButton({
  ariaLabel = "Clear",
  className,
  onPress,
}: ClearButtonProps) {
  return (
    <Button
      className={className}
      isIconOnly
      onPress={onPress}
      size="sm"
      variant="plain"
    >
      <X
        aria-label={ariaLabel}
        className="rounded-full border-3 border-border-tertiary bg-bg-tertiary text-fg-quaternary"
        size={22}
      />
    </Button>
  );
}
